/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CalculatorIcon20Light = forwardRef('CalculatorIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.5 5a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2h-5Z" }),
        React.createElement("path", { d: "M8.297 10.15a.85.85 0 1 1-1.698 0 .85.85 0 0 1 1.698 0Z" }),
        React.createElement("path", { d: "M7.445 14a.852.852 0 1 0 0-1.703.852.852 0 0 0 0 1.703Z" }),
        React.createElement("path", { d: "M10.852 10.148a.852.852 0 1 1-1.704 0 .852.852 0 0 1 1.704 0Z" }),
        React.createElement("path", { d: "M10 14a.852.852 0 1 0 0-1.703A.852.852 0 0 0 10 14Z" }),
        React.createElement("path", { d: "M13.407 10.148a.852.852 0 1 1-1.704 0 .852.852 0 0 1 1.704 0Z" }),
        React.createElement("path", { d: "M12.555 14a.852.852 0 1 0 0-1.703.852.852 0 0 0 0 1.703Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H7ZM5 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5Z" })));
});
